import { useTranslation } from "react-i18next";
import { DistanceUnit, DistanceValueUnit } from "../enums/configuration/units";
import { useSharedSelector } from "../store/SharedProvider";
import { selectDistanceUnit } from "../store/app-configurations/app-configurations-selectors";

const useDistanceUnitValue = (value: number, valueUnit: DistanceValueUnit, round?: boolean) => {
  const { t } = useTranslation();

  const distanceUnit = useSharedSelector((state) => selectDistanceUnit(state));

  const METERS_TO_FEET = 3.28084;
  const SQ_METERS_TO_SQ_FEET = 10.7639;

  let converted = value;
  let multiplier = 1;

  if (distanceUnit === DistanceUnit.IMPERIAL) {
    if (valueUnit === DistanceValueUnit.METERS) {
      converted = value * METERS_TO_FEET;
      multiplier = METERS_TO_FEET
    } else if (
      valueUnit === DistanceValueUnit.METERS_SQUARED ||
      valueUnit === DistanceValueUnit.METERS_SQUARED_PER_HOUR
    ) {
      converted = value * SQ_METERS_TO_SQ_FEET;
      multiplier = SQ_METERS_TO_SQ_FEET
    }
  }

  if (round) {
    converted = Math.round(converted);
  } else {
    // show up to 2 decimals by default
    converted = Math.round(converted * 100) / 100;
  }

  let label = "";

  if (distanceUnit === DistanceUnit.METRIC) {
    label =
      valueUnit === DistanceValueUnit.METERS
        ? t("meter-unit")
        : valueUnit === DistanceValueUnit.METERS_SQUARED
        ? t("label-meters-squared-unit")
        : t("label-cleaning-performance-unit");
  } else {
    label =
      valueUnit === DistanceValueUnit.METERS
        ? t("label-feet")
        : valueUnit === DistanceValueUnit.METERS_SQUARED
        ? t("label-feet-squared-unit")
        : t("label-feet-squared-per-hour-unit");
  }

  return { converted, label, multiplier };
};

export default useDistanceUnitValue;
